module.exports = __webpack_public_path__ + "assets/4c62bc5343b3cb035f92ba4605d9ffe4.png";